module.exports = __webpack_public_path__ + "img/urban_artistic_voyager.51a78b79.png";